import React from 'react';
import { StyleProp, StyleSheet, TextStyle } from 'react-native';

import { useColors } from '../../hooks';
import useDevice from '../../hooks/use-device';
import TranslatableText2 from '../translatable-text2';

interface LessonInstructionsProps {
  translation?: string;
  children?: React.ReactNode;
  style?: StyleProp<TextStyle>;
  type?: 'onPrimary' | 'gray';
}

const LessonInstructions: React.FC<LessonInstructionsProps> = ({
  children,
  translation,
  style,
  type = 'onPrimary',
}) => {
  const colors = useColors();
  const { isDesktop } = useDevice();

  const skeletonBackgroundColor =
    type === 'onPrimary' ? colors.primaryOpacity : colors.offWhite;
  const skeletonGradientColor =
    type === 'onPrimary' ? colors.primaryLight : colors.borderColor;

  return (
    <TranslatableText2
      style={[styles.text, style]}
      fontSize={18}
      type={type}
      fontWeightStyle="bold"
      translation={translation}
      skeletonBackgroundColor={skeletonBackgroundColor}
      skeletonGradientColor={skeletonGradientColor}
      // eslint-disable-next-line react-native/no-inline-styles
      skeletonStyle={{ width: isDesktop ? '60%' : '80%' }}
    >
      {children}
    </TranslatableText2>
  );
};

export default LessonInstructions;

const styles = StyleSheet.create({
  text: {
    textAlign: 'center',
    alignItems: 'center',
  },
});
